import { Answer } from '.'
import Question from './Question'

export default class QuestionTree {
  public readonly question: Question
  public readonly index: number
  public readonly outOf?: number
  public readonly children?: Map<string, QuestionTree>
  public parent?: QuestionTree

  private constructor (question: Question, index: number, outOf?: number, parent?: QuestionTree, children?: Map<string, QuestionTree>) {
    this.question = question
    this.index = index
    this.outOf = outOf
    this.children = children
    this.parent = parent
  }

  public static make (questions: Question[], startUid: string, index = 1, parent?: QuestionTree): QuestionTree {
    const root = questions.find(q => q.uid === startUid)
    if (!root) {
      throw new Error('Cannot find start question')
    }
    const remainingQuestions = questions.filter(q => q.uid !== startUid)
    const nextQuestionUids = new Set<string>(
      root.answers.filter(a => !!a.nextQuestionId).map(
        (a) => a.nextQuestionId as string
      )
    )
    const isSplitPath = new Set(root.answers.map(a => a.nextQuestionId)).size > 1

    if (!remainingQuestions.length || !nextQuestionUids.size) {
      return new QuestionTree(root, index, index, parent)
    }

    const children = new Map<string, QuestionTree>()
    root.answers
      .forEach(
        ({ uid, nextQuestionId }: Answer) => {
          if (!nextQuestionId) {
            return
          }
          children.set(uid, QuestionTree.make(remainingQuestions, nextQuestionId, isSplitPath ? 1 : index + 1))
        }
      )

    const outOf = isSplitPath ? undefined : children.values().next().value?.outOf

    const thisTree = new QuestionTree(root, index, outOf, parent, children)
    children.forEach(c => {
      c.parent = thisTree
    })
    return thisTree
  }
}
